import React from 'react';
import createReactClass from 'create-react-class';
var ErrorBox = createReactClass({
	render: function() {
		return(
			<div style={{color: 'red'}}>{this.props.message}</div>
		)
	}
});
export default ErrorBox;